// src/components/ImagePickers.jsx
import React, { useState } from "react";
import { Upload, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";

/** Simple helper like AntD docs */
export const normFile = (e) => (Array.isArray(e) ? e : e?.fileList || []);

const BasePicker = ({
  multiple,
  value = [],
  onChange,
  listType = "picture-card",
  maxCount,
  accept = "image/*",
  disabled = false,
  buttonText = "Upload",
  ...rest
}) => {
  const [preview, setPreview] = useState({ open: false, src: "", title: "" });

  return (
    <>
      <Upload
        multiple={multiple}
        listType={listType}
        fileList={value}
        onChange={({ fileList }) => onChange?.(fileList)}
        onRemove={() => true}
        onPreview={(file) =>
          setPreview({
            open: true,
            src: file.url || file.thumbUrl,
            title: file.name || "Preview",
          })
        }
        beforeUpload={() => false} // prevent auto-upload
        maxCount={maxCount}
        accept={accept}
        disabled={disabled}
        {...rest}
      >
        {(!maxCount || (value?.length || 0) < maxCount) && (
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>{buttonText}</div>
          </div>
        )}
      </Upload>

      <Modal
        open={preview.open}
        title={preview.title}
        footer={null}
        onCancel={() => setPreview((p) => ({ ...p, open: false }))}
      >
        <img alt="preview" style={{ width: "100%" }} src={preview.src} />
      </Modal>
    </>
  );
};

export function ImageUploadSingle(props) {
  return <BasePicker multiple={false} maxCount={1} {...props} />;
}

export function ImageUploadMulti(props) {
  return <BasePicker multiple {...props} />;
}
